<template>
  <div @click="outsideClick()" class="modal">
    <div class="modal-box">
      <div @click="$emit('close')" class="close">
        <span>X</span>
      </div>
      <div class="modal-body" style="max-width: 680px;">
        <div class="form-box" style="padding: 1rem;">
          <h4>Complete os campos a seguir com as demais informações de cadastro.</h4>
          <h5>É muito importante preencher todos os campos, pois será com base nesses dados que tracionaremos os cálculos de alguns riscos preditivos.</h5>
          <div>
            <button class="button btn-orange" style="width: 100%;margin: 21px 0;" v-on:click.prevent="$emit('close')">
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "register-profile-modal",
    }
</script>



// WEBPACK FOOTER //
// src/components/ProfileIncompleteModal/RegisterProfileModal.vue